<template>
	<div class="report">
		<div class="report-header">
			<div class="page-header">
				<div class="logo" @click="goHome">
					<img src="@/assets/images/logo@2x.png" alt="" />
				</div>
				<div class="tools" v-if="!props.isDelete">
					<a-button v-if="props.visibleShare" type="primary" @click="share">分享报告</a-button>
					<a-button v-else type="primary" @click="goHome">免费体验</a-button>
				</div>
			</div>
		</div>
		<div class="box">
			<div v-if="!props.isDelete" class="box-header">
				<div class="info">
					本报告由 轻舟能科储能精算师 生成于
					{{ moment(props.shareData.createDate).format("YYYY年MM月DD日") }}
				</div>
			</div>
			<div v-if="!isDelete" class="line"></div>
			<div v-if="!isDelete" class="box-content">
				<div class="title">
					<div class="font">{{ props.shareData.name }}配储测算报告</div>
				</div>

				<div class="info-card">
					<div class="primary-title">一、负载情况</div>
					<div class="second-title">
						{{ props.shareData.name }}项目位于【{{ props.shareData.province }}】{{ props.shareData.area == "全省" ? "" : `【${props.shareData.area}】` }}，在{{
							moment(props.shareData.startDate).format("YYYY年MM月DD日")
						}}～{{ moment(props.shareData.endDate).format("YYYY年MM月DD日") }}之间共{{ props.shareData.loadDays }}天内，总用电量{{
							toFixed(props.shareData.sumElec / 1000, 2) || "-"
						}}
						MWh，日均用电量{{ props.shareData.meanElec || "-" }}
						kWh，详细用电情况如下图：
					</div>
					<div class="echarts">
						<div class="echarts-title">
							<div class="font">电量数据概览</div>
							<div class="icon">
								<a-tooltip placement="right">
									<template #title>概览每天用电量变化情况</template>
									<InfoCircleOutlined />
								</a-tooltip>
							</div>
						</div>
						<div class="echarts-box">
							<echarts-component :options="props.electricityOverviewOptions"></echarts-component>
						</div>
					</div>
					<div class="echarts">
						<div class="detail-infos mt8">
							依据"储能精算师"聚类规则，
							<span v-for="(item, index) in typicalDates" :key="index">
								<span class="special">{{ item }}</span>
								{{ index == typicalDates.length - 1 ? "" : "、" }}
							</span>
							为{{ typicalDates.length }}种典型负荷曲线，可分别代表
							<span v-for="(item, index) in typicalDays" :key="index">
								<span class="special">{{ item }}天</span>
								{{ index == typicalDays.length - 1 ? "" : "、" }}
							</span>
							的负载数据，其他负荷曲线与这{{ typicalDays.length }}日的负荷曲线最接近，选取这{{ typicalDays.length }}日负荷作为典型日负荷。典型日负荷变化曲线如下图:
						</div>
						<div class="echarts-title">
							<div class="font">典型日负荷</div>
							<div class="icon">
								<a-tooltip placement="right">
									<template #title>典型日负荷是算法根据负载数据聚合出的特征曲线，代表了负荷在一天内波动的情况。</template>
									<InfoCircleOutlined />
								</a-tooltip>
							</div>
						</div>
						<div class="echarts-box">
							<echarts-component :options="props.typicalLoadOptions"></echarts-component>
						</div>
					</div>
					<div class="tips">鉴于以上情况，可以考虑为项目增配储能，以实现削峰填谷、控制需量等效果，为企业降低用电成本，提升环保指数。</div>
				</div>

				<div class="info-card">
					<div class="primary-title">二、配储评估</div>
					<div class="second-title">分析使用的储能系统参数如下表：</div>
					<!-- 参数表 -->
					<parameter-lists :strategyCurveListData="strategyCurveListData"></parameter-lists>

					<div v-if="jobStepVO" class="detail-infos mt8">
						从
						<span class="special">{{ jobStepVO.initPower || "-" }}kW/{{ jobStepVO.initCapacity || "-" }}kWh</span>
						开始，以
						<span class="special">{{ jobStepVO.periodPower || "-" }}kW/{{ jobStepVO.periodCapacity || "-" }}kWh</span>
						的储能规模逐步叠加进行模拟运行，结果如下:
					</div>
					<div class="echarts">
						<div class="echarts-title">
							<div class="font">日均收益</div>
							<div class="icon">
								<a-tooltip
									:overlayStyle="{
										whiteSpace: 'nowrap',
										maxWidth: 'none',
									}"
									placement="right"
								>
									<template #title>储能日均收益 = 统计时间内总收益（元） / 天数。</template>
									<InfoCircleOutlined />
								</a-tooltip>
							</div>
						</div>
						<div class="echarts-box">
							<echarts-component :options="props.dailyIncomeOptions"></echarts-component>
						</div>
					</div>
					<div class="echarts" style="margin-bottom: 0px">
						<div class="echarts-title">
							<div class="font">单位容量日均收益</div>
							<div class="icon">
								<a-tooltip
									placement="right"
									:overlayStyle="{
										whiteSpace: 'nowrap',
										maxWidth: 'none',
									}"
								>
									<template #title>单位容量日均收益 = 储能日均收益（元/天） / 装机容量（kWh）</template>
									<InfoCircleOutlined />
								</a-tooltip>
							</div>
						</div>
						<div class="echarts-box">
							<echarts-component :options="props.unitCapacityOptions"></echarts-component>
						</div>
					</div>
					<!-- v1新增表格 -->
					<div style="margin-top: 16px">
						<income-detail-table :averageDatas="props.averageDatas"></income-detail-table>
					</div>
				</div>

				<div class="info-card">
					<div class="primary-title">三、配储方案</div>
					<scheme-methods :schemeMethodsInfo="props.schemeMethodsInfo" :typicalDates="typicalDates"></scheme-methods>
				</div>
				<div class="info-card">
					<div class="primary-title">四、经济分析</div>
					<div class="detail-infos mt8">分析使用的经济参数如下表：</div>
					<economic-analysis :economicInfo="props.economicInfo"></economic-analysis>
				</div>
			</div>
			<div v-else class="box-content">
				<div class="empty">
					<img src="@/assets/images/emptyProject.png" alt="" />
					<div class="font">该链接已失效</div>
				</div>
			</div>
		</div>
		<div class="copyright">
			<img src="@/assets/images/foot@2x.png" alt="" @click="goCompanyHome" />
			<!-- <div class="line"></div>
			<div class="font">Copyright © 2023 杭州轻舟科技有限公司</div> -->
		</div>
	</div>
</template>

<script setup>
import {defineProps, onMounted, ref, watch} from "vue";
// 引入echarts
import EchartsComponent from "@/components/EchartsComponent.vue";
// 引入setNotOpt
import {toFixed, goCompanyHome} from "@/plugins/index.js";
import {InfoCircleOutlined} from "@ant-design/icons-vue";
// 引入moment
import moment from "moment";
// 引入route
import {useRouter} from "vue-router";
const router = useRouter();
// 引入message
import {message} from "ant-design-vue";
import IncomeDetailTable from "../../../components/IncomeDetailTable.vue";
// 配储方案
import SchemeMethods from "./components/PC/SchemeMethods.vue";
// 经济分析
import EconomicAnalysis from "./components/PC/EconomicAnalysis.vue";
// 配储评估参数表
import ParameterLists from "../components/PC/ParameterLists.vue";

let props = defineProps({
	shareKey: {
		type: String,
		default: "",
	},
	isDelete: {
		type: Boolean,
		default: false,
	},
	visibleShare: {
		type: Boolean,
		default: true,
	},
	shareData: {
		type: Object,
		default: () => {},
	},

	electricityOverviewOptions: {
		type: Object,
		default: () => {},
	},
	typicalLoadOptions: {
		type: Object,
		default: () => {},
	},
	dailyIncomeOptions: {
		type: Object,
		default: () => {},
	},
	unitCapacityOptions: {
		type: Object,
		default: () => {},
	},
	// 配储分析参数
	strategyCurveListData: {
		type: Array,
		default: () => {
			return [];
		},
	},
	v1ReportInfos: {
		type: Object,
		default: () => {
			return null;
		},
	},
	averageDatas: {
		type: Object,
		default: () => {},
	},
	// 配储方案数据
	schemeMethodsInfo: {
		type: Object,
		default: () => {
			return null;
		},
	},
	// 经济分析数据
	economicInfo: {
		type: Object,
		default: () => {
			return null;
		},
	},
});

// 负载典型日日期
const typicalDates = ref([]);
// 负载典型日天数
const typicalDays = ref([]);
// 储能规模
const jobStepVO = ref({
	initPower: undefined,
	initCapacity: undefined,
	periodPower: undefined,
	periodCapacity: undefined,
});

watch(
	() => props.v1ReportInfos,
	newVal => {
		if (newVal) {
			console.log("newVal", newVal);
			typicalDates.value = newVal.typicalDates;
			typicalDays.value = newVal.typicalDays;
			jobStepVO.value = newVal.jobStepVO;
		}
	},
	{immediate: true, deep: true}
);

const goHome = () => {
	router.push("/");
};
// 分享报告
const share = () => {
	const textToCopy = `${window.location.origin}/report/v1?shareKey=${props.shareKey}`;
	// 创建一个临时的 textarea 元素
	const textarea = document.createElement("textarea");
	textarea.value = textToCopy;
	document.body.appendChild(textarea);
	// 选择并复制文本
	textarea.select();
	document.execCommand("copy");
	// 清理临时元素
	document.body.removeChild(textarea);
	message.success("已复制报告链接");
};

onMounted(() => {
	console.log(props.averageDatas);
});
</script>

<style lang="less" scoped>
.report {
	width: 100%;
	height: 100%;
	// padding: 16px 0px;
	// min-width: 1440px;
	min-height: 100vh;
	background-image: url(~@/assets/images/bg2.png);
	background-color: #eaeff6;
	background-repeat: no-repeat;
	background-size: 100% auto;
	// background-size: 100% 100%;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;

	&-header {
		width: 100%;
		height: 64px;
		background: #ffffff;
		border: 1px solid #dbe0e8;
		position: relative;
		margin-bottom: 16px;
		.logo {
			position: absolute;
			left: 32px;
			bottom: 12px;

			img {
				width: 148px;
				height: 40px;
			}
		}
		.tools {
			position: absolute;
			right: 24px;
			top: 50%;
			font-size: 16px;
			transform: translateY(-50%);

			font-family: PingFangSC-Medium;
			font-size: 14px;
			color: #000000;
			letter-spacing: 0;
			text-align: right;
		}
	}

	.box {
		width: 80rem;
		flex: 1;
		position: relative;
		background-color: white;
		padding: 19px 24px;
		border: 1px solid #dbe0e8;
		border-radius: 4px;

		&-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			border-bottom: 1px solid #a2abbb;
			padding-bottom: 13px;
			width: 100%;

			.info {
				height: 22px;
				width: 100%;
				opacity: 0.65;
				font-family: PingFangSC-Regular;
				font-weight: 400;
				font-size: 14px;
				color: #000000;
				letter-spacing: 0;
				text-align: center;
				line-height: 22px;
			}
		}

		.line {
			width: 100%;
			height: 4px;
			background: #a2abbb;
			margin-top: 2px;
		}

		&-content {
			margin-top: 28px;

			.title {
				position: relative;
				display: flex;
				margin-bottom: 28px;

				.font {
					width: 100%;
					font-family: PingFangSC-Medium;
					font-weight: 500;
					font-size: 28px;
					color: #000000;
					letter-spacing: 0;
					text-align: center;
					line-height: 36px;
					padding: 0 32px;
				}

				button {
					position: absolute;
					right: 0;
					top: 50%;
					transform: translateY(-50%);
				}
			}

			.info-card {
				min-height: 500px;
				background: #e9eff633;
				border: 1px solid #a2abbb66;
				border-radius: 4px;
				margin-bottom: 16px;
				padding: 24px 32px;

				.primary-title {
					height: 32px;
					opacity: 0.85;
					font-family: PingFangSC-Medium;
					font-weight: 500;
					font-size: 24px;
					color: #000000;
					letter-spacing: 0;
					line-height: 32px;
					margin-bottom: 12px;
				}

				.second-title {
					opacity: 0.85;
					font-family: PingFangSC-Regular;
					font-weight: 400;
					font-size: 16px;
					color: #000000;
					letter-spacing: 0;
					line-height: 28px;
					margin-bottom: 8px;
				}

				.echarts {
					margin-bottom: 32px;
					&-title {
						display: flex;
						align-items: center;
						margin-bottom: 8px;

						.font {
							height: 24px;
							opacity: 0.85;
							font-family: PingFangSC-Medium;
							font-weight: 600;
							font-size: 16px;
							color: #000000;
							letter-spacing: 0;
							line-height: 24px;
						}

						.icon {
							width: 14px;
							height: 14px;
							color: #b2b2b2;
							margin-left: 7px;
						}
					}

					&-box {
						height: 317px;
					}
				}

				.second-tips {
					line-height: 22px;
					height: 66px;
					opacity: 0.65;
					font-family: PingFangSC-Regular;
					font-weight: 400;
					font-size: 14px;
					color: #000000;
					letter-spacing: 0;
					line-height: 22px;
				}
			}

			.empty {
				text-align: center;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				.font {
					width: 100%;
					text-align: center;
					height: 28px;
					opacity: 0.85;
					font-family: PingFangSC-Medium;
					font-weight: 500;
					font-size: 18px;
					color: #000000;
					letter-spacing: 0;
					text-align: center;
					line-height: 28px;
					margin-top: 32px;
				}
			}
		}
	}

	.copyright {
		text-align: center;
		z-index: 9999;
		margin: 12px 0px;
		cursor: pointer;
		img {
			width: 385px;
			height: 24px;
		}
	}
}
</style>

<style lang="less">
.tips {
	height: 48px;
	background: #0058fc14;
	border: 1px solid #0058fc3d;
	border-radius: 4px;
	padding: 12px 16px;

	font-family: PingFangSC-Medium;
	font-weight: 600;
	font-size: 16px;
	color: #0058fc;
	letter-spacing: 0;
	line-height: 24px;
}

.detail-infos {
	color: #000000d9;
	font-size: 16px;
	font-family: PingFangSC;
	font-weight: 400;
	line-height: 24px;
	letter-spacing: 0;
	text-align: justify;
	margin-bottom: 8px;
	.special {
		color: #0058fc;
		font-weight: 500;
	}
}
.mt8 {
	margin-bottom: 8px !important;
}
</style>
